module.exports = __webpack_public_path__ + "img/talents3.0578d8ba.jpg";